cv.PublicSearchView = Marionette.LayoutView.extend({
  template: cv.Templates["public/xsearch/search"],

  regions: {
    tab_content: "#tab-content",
  },

  events: {
    "click .search-toggle a": "changeTab",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    console.log("PublicSearchView initialized");
  },

  templateHelpers: function () {
    return {
      enable_teams: cv.campaign.get("enable_teams") == 1 ? true : false,
    };
  },

  changeTab: function (e) {
    if (_.isObject(e)) {
      e.preventDefault();
      var tab = $(e.currentTarget).attr("id").split("-")[1];
    } else {
      var tab = e;
    }

    this.$(".search-toggle a").removeClass("active");
    this.$("#toggle-" + tab).addClass("active");

    switch (tab) {
      case "fundraisers":
        var view = new cv.PublicSearchFundraisersView({
          collection: new cv.ProjectsNew(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              sort: "display_funds_raised",
              order: "desc",
              limit: 20,
            },
          }),
        });
        break;
      case "teams":
        var view = new cv.PublicSearchTeamsView({
          collection: new cv.TeamsNew(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              sort: "display_funds_raised",
              order: "desc",
              limit: 20,
            },
          }),
        });
        break;
      case "posts":
        var view = new cv.PublicSearchPostsView({
          collection: new cv.Posts(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              limit: 20,
            },
          }),
        });
        break;
      default:
        var view = new cv.PublicSearchFundraisersView({
          collection: new cv.Projects(null, {
            params: {
              api_key: cv.PRELOADED.public_api_key,
              filters: ["active:eq:1"],
              limit: 20,
            },
          }),
        });
    }
    this.showChildView("tab_content", view);

    // Replace the URL
    cv.router.navigate("/search/" + tab, { replace: true });
  },

  onAttach: function () {
    this.changeTab(this.options.tab);
  },
});
